export function detectarMascara(value) {
    const DDDS_VALIDOS = [
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "21",
        "22",
        "24",
        "27",
        "28",
        "31",
        "32",
        "33",
        "34",
        "35",
        "37",
        "38",
        "41",
        "42",
        "43",
        "44",
        "45",
        "46",
        "47",
        "48",
        "49",
        "51",
        "53",
        "54",
        "55",
        "61",
        "62",
        "64",
        "65",
        "66",
        "67",
        "68",
        "69",
        "71",
        "73",
        "74",
        "75",
        "77",
        "79",
    ];
    const numbers = value.replace(/\D/g, "");

    // 1) SAG — qualquer número que comece com 0
    if (numbers.startsWith("0")) {
        return "9999 999 9999";
    }

    // Só tenta interpretar DDD depois de 2 dígitos
    if (numbers.length >= 2) {
        const ddd = numbers.substring(0, 2);

        // Se DDD válido → analisar tipo do telefone
        if (DDDS_VALIDOS.includes(ddd)) {
            const afterDDD = numbers.substring(2); // após os 2 do DDD

            if (afterDDD.length > 0) {
                const firstLocalDigit = afterDDD.substring(0, 1);

                // 2) FIXO → começa com 2,3,4,5 e tem até 10 dígitos
                if (["2", "3", "4", "5"].includes(firstLocalDigit)) {
                    return "(99) 9999-9999";
                }

                // 3) CELULAR → começa com 9
                if (firstLocalDigit === "9") {
                    return "(99) 99999-9999";
                }

                // 4) Qualquer outro → assumir CELULAR (mais seguro)
                return "(99) 99999-9999";
            }
        }

        // DDD inválido → assume CELULAR
        return "(99) 99999-9999";
    }

    // Antes de digitar o DDD
    return "";
}
